var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNgMaterial(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 509,
    height: 405,
    viewBox: "0 0 509 405",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 214.712,
    y: 423.712,
    width: 228.696,
    height: 576.999,
    transform: "rotate(-135 214.712 423.712)",
    fill: "url(#paint0_linear)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 284.712,
    y: 618.712,
    width: 228.696,
    height: 576.999,
    transform: "rotate(-135 284.712 618.712)",
    fill: "url(#paint1_linear)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123,
    y: 314,
    width: 41.0122,
    height: 576.999,
    transform: "rotate(-135 123 314)",
    fill: "url(#paint2_linear)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: -15,
    y: 276,
    width: 41.0122,
    height: 576.999,
    transform: "rotate(-135 -15 276)",
    fill: "url(#paint3_linear)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M425.619 84.5869L425.412 84.8372L398.129 97.9475L415.581 76.5156L425.619 84.5869Z",
    fill: "#A6B9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.949 30.5655C476.531 29.221 475.197 28.3843 473.802 28.5957L378.471 43.0059C377.364 43.1756 376.459 43.973 376.153 45.0488C375.851 46.1258 376.205 47.2799 377.062 48.0003L401.193 68.3495C401.467 68.5803 401.777 68.755 402.104 68.8674C402.804 69.1083 403.588 69.0725 404.279 68.7319L475.48 33.9726C476.743 33.3587 477.371 31.9076 476.949 30.5655V30.5655Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.997 29.1774C474.97 28.3785 473.53 28.3612 472.493 29.1574L413.843 74.2581C413.151 74.7872 412.739 75.6098 412.732 76.483C412.725 77.3562 413.114 78.1887 413.798 78.7333L442.071 101.511C442.332 101.721 442.622 101.881 442.931 101.988C443.437 102.162 443.99 102.191 444.523 102.065C445.381 101.858 446.096 101.264 446.457 100.461L476.831 32.5811C477.366 31.3874 477.021 29.9835 475.997 29.1774V29.1774Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.231 31.4145L413.794 78.7324L398.129 97.947L400.617 67.3521L474.231 31.4145Z",
    fill: "#D2DCEE"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 405,
    y1: 134.586,
    x2: 431.586,
    y2: 108,
    stroke: "#D2DCEE",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 364,
    y1: 92.5858,
    x2: 376.586,
    y2: 80,
    stroke: "#D2DCEE",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 330,
    y1: 162.586,
    x2: 384.586,
    y2: 108,
    stroke: "#D2DCEE",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 329.06,
    y1: 1000.71,
    x2: 329.06,
    y2: 561.551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.338542,
    stopColor: "#D2DCEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2DCEE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 399.06,
    y1: 1195.71,
    x2: 399.06,
    y2: 756.551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.338542,
    stopColor: "#D2DCEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2DCEE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 143.506,
    y1: 890.999,
    x2: 143.506,
    y2: 451.839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.338542,
    stopColor: "#D2DCEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2DCEE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 5.50611,
    y1: 852.999,
    x2: 5.50611,
    y2: 413.839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.338542,
    stopColor: "#D2DCEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2DCEE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 509,
    height: 405,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 91.1603,
    height: 91.1603,
    fill: "white",
    transform: "translate(391.647) rotate(18.9789)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNgMaterial);
export default __webpack_public_path__ + "static/media/ngMaterial.9b8c9de21a47130bf7569f6476050e4c.svg";
export { ForwardRef as ReactComponent };